const i18n = {
  'en-US': {
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.newPassword': 'New Password',
    'auth.code': 'Code',
    'auth.send': 'Send',
    'auth.return': 'Return to sign in',
    'auth.confirm': 'Confirm',
    'auth.message.restPasswordSuccess': 'Reset password success',
    'login.form.title': 'Sign in to your account',
    'login.form.email': 'Email',
    'login.form.password': 'Password',
    'login.form.userName.errMsg': 'Please enter your email',
    'login.form.password.errMsg': 'Incorrect email or password.',
    'login.form.login.errMsg': 'Login error, please refresh and try again',
    'login.form.userName.placeholder': 'Username: admin',
    'login.form.password.placeholder': 'Password: admin',
    'login.form.rememberPassword': 'Remember password',
    'login.form.forgetPassword': 'Forgot your password?',
    'login.form.login': 'Sign in',
    'login.form.register': 'New to TTYHUB? Create account',
    'login.form.login.failed': 'Login failed',
    'login.banner.slogan1': 'Out-of-the-box high-quality template',
    'login.banner.subSlogan1': 'Rich page templates, covering most typical business scenarios',
    'login.banner.slogan2': 'Built-in solutions to common problems',
    'login.banner.subSlogan2': 'Internationalization, routing configuration, state management everything',
    'login.banner.slogan3': 'Access visualization enhancement tool AUX',
    'login.banner.subSlogan3': 'Realize flexible block development',
    'register.title': 'Create your account',
    'register.form.agree': "I agree With TTYHUB's ",
    'register.form.service': 'Terms of Service',
    'register.form.privacy': 'Privacy Policy',
    'register.form.and': 'and',
    'register.form.register': 'Create account',
    'register.form.login': 'Already have an account? Sign in',
    'register.form.send': 'Send',
    'register.form.email': 'Email',
    'register.form.password': 'Password',
    'register.form.code': 'Code',
    'register.form.email.errMsg': 'Email cannot be empty',
    'register.form.password.errMsg': 'Password cannot be empty',
    'register.form.code.errMsg': 'Code cannot be empty',
    'register.form.emailCheck.errMsg': 'Email cannot be empty',
    'register.form.retry': 's',
    'register.form.code.success': 'Send success',
    'register.form.code.failed': 'Send failed',
    'forgot.form.title': 'Reset your password'
  },
  'zh-CN': {
    'auth.email': '邮箱',
    'auth.password': '密码',
    'auth.newPassword': '新密码',
    'auth.code': '验证码',
    'auth.send': '发送',
    'auth.return': '返回登录',
    'auth.confirm': '确认',
    'auth.message.restPasswordSuccess': '密码重置成功',
    'login.form.title': '登录您的账号',
    'login.form.email': '邮箱',
    'login.form.password': '密码',
    'login.form.userName.errMsg': '用户名不能为空',
    'login.form.password.errMsg': '密码不能为空',
    'login.form.login.errMsg': '登录出错，请刷新重试',
    'login.form.userName.placeholder': '用户名：admin',
    'login.form.password.placeholder': '密码：admin',
    'login.form.rememberPassword': '记住登录状态',
    'login.form.forgetPassword': '忘记密码？',
    'login.form.login': '登录',
    'login.form.register': '没有账号？去注册',
    'login.form.login.failed': '账号密码不匹配',
    'login.banner.slogan1': '开箱即用的高质量模板',
    'login.banner.subSlogan1': '丰富的的页面模板，覆盖大多数典型业务场景',
    'login.banner.slogan2': '内置了常见问题的解决方案',
    'login.banner.subSlogan2': '国际化，路由配置，状态管理应有尽有',
    'login.banner.slogan3': '接入可视化增强工具AUX',
    'login.banner.subSlogan3': '实现灵活的区块式开发',
    'register.title': '注册TTYHub账号',
    'register.form.agree': '注册即表示我已阅读并同意',
    'register.form.service': '服务协议',
    'register.form.privacy': '隐私协议',
    'register.form.and': '和',
    'register.form.register': '创建账户',
    'register.form.login': '已有账号？ 立即登录',
    'register.form.send': '获取验证码',
    'register.form.email': '登录邮箱',
    'register.form.password': '密码',
    'register.form.code': '验证码',
    'register.form.email.errMsg': '请输入邮箱地址',
    'register.form.password.errMsg': '请输入密码',
    'register.form.code.errMsg': '请输入验证码',
    'register.form.emailCheck.errMsg': 'Email校验失败',
    'register.form.retry': '秒后重试',
    'register.form.code.success': '发送成功',
    'register.form.code.failed': '发送失败',
    'forgot.form.title': '重置密码'
  }
};
export default i18n;